import getCompanies from './getCompanies'
import getCompany from './getCompany'
import getActivities from './getActivities'
import getPartners from './getPartners'
import getConnections from './getConnections'
import getConnectionInfo from './getConnectionInfo'
import updateInfo from './updateInfo'

export default {getCompanies, getCompany, getActivities, getPartners, getConnections, getConnectionInfo, updateInfo}
